import React, {Component, useState} from 'react'
import {LayoutHeaderConfig} from 'components/MainLayout'
import {Button, Input, Row, Typography, Radio, message, Col} from "antd";
import './Gift.css'
import {bindActionCreators} from "redux";
import {fetchDiscounts, fetchPlans} from "../../store/billing/actions";
import {selectDiscounts, selectPlans} from "../../store/billing/reducer";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import NewDiscount from "./GiftCode";
import DiscountList from "./GiftList";
import {getBillingApi} from "../../api";

const {Title, Paragraph} = Typography;

class Gift extends Component {

    constructor(props) {
        super(props);
        this.state = {
            giftList: []
        }
    }

    componentDidMount() {
        this.props.fetchDiscounts();
    }


    render() {
        return <React.Fragment>
            <LayoutHeaderConfig closeable={true} pageTitle="هدیه" menuEnabled={false} extra={[]}/>
            <Row className='px-40'>
                <Col span={24} className="">
                    <Title level={2} className='mb-36 f-30'>هدیه و تخفیف</Title>
                </Col>
            </Row>
            <React.Fragment>

                <NewDiscount fetchDiscounts={this.props.fetchDiscounts}/>
                <hr/>
                <DiscountList discounts={this.props.discounts} onClick={this.onClick}/>

            </React.Fragment>
        </React.Fragment>
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        fetchDiscounts,
    },
    dispatch);

const mapStateToProps = state => ({
    discounts: selectDiscounts(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Gift))
